<template>
  <div class="container">
    <div class="header-img">
      <img src="../../assets/images/drugcoupon/header.png" alt="">
    </div>
    <div class="content">
      <div class="custom-form">
        <div v-if="state === 0">
          <div class="phone-desc">
            <p class="desc-1">恭喜您！领取成功</p>
            <p class="desc-2">当前领取账户：{{phone}}</p>
          </div>
          <img class="coupon-img" src="../../assets/images/drugcoupon/juanyou.png" alt="">
        </div>
        <div v-if="state === 1">
          <div class="phone-desc">
            <p class="desc-2">您已经领取过优惠券，可直接在便捷青岛APP“领券中心”领取更多优惠~</p>
          </div>
        </div>
        <div v-if="state === 2">
          <div class="phone-desc">
            <p class="desc-2">很遗憾，您来晚了<br/>用户专享券已抢光了～</p>
          </div>
        </div>
        <div v-if="state === 3">
          <img class="coupon-img" src="../../assets/images/drugcoupon/juanyou.png" alt="">
        </div>
        <div class="form-item form-item-button">
          <button class="form-button" @click="handleDown">下载便捷青岛使用</button>
        </div>
      </div>
      <rule-page></rule-page>
      <van-popup v-model="show" class="custom-popup" :close-on-click-overlay="false">
        <div class="phone-desc">
          <p class="desc-1">不好意思，您来晚了～</p>
          <p class="desc-2">该活动已结束，领取更多优惠，请<br/>下载便捷青岛APP</p>
        </div>
        <div class="form-item form-item-button">
          <button class="form-button" @click="handleDown">下载便捷青岛APP</button>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import RulePage from './rule'
import { Popup } from 'vant'

export default {
  components: {
    [Popup.name]: Popup,
    RulePage: RulePage
  },
  data () {
    return {
      phone: '',
      state: null, // 新用户0，老用户1，已抢光2，活动结束3
      show: false
    }
  },
  mounted () {
    this.state = +this.$route.query.state
    let reg = /^(\d{3})\d*(\d{4})$/
    if (this.$route.query.phone) {
      this.phone = this.$route.query.phone.replace(reg, '$1****$2')
    }
    if (this.state >= 3) {
      this.show = true
    }
  },
  methods: {
    handleDown (e) {
      e.preventDefault()
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
    }
  }
}

</script>
<style lang='scss' scoped>
.container {
  height: 100vh;
  background-size: 100%;
  background: #f8f8f8;
}
.custom-popup {
  margin-top: 50px;
  padding: 150px 15px 20px;
  border-radius: 10px;
  width: 80%;
  height: 400px;
  background: url('../../assets/images/drugcoupon/activebg.png') no-repeat left top;
  background-size: 100%;
}
.popup-img {
  position: relative;
  left: 35px;
  top: 30px;
  width: 250px;
  margin: 0 auto;
  z-index: 2003;
}
.header-img {
  img {
    width: 100%;
  }
}
.coupon-img {
  img {
    width: 100%;
  }
}
.content {
  position: relative;
  top: -42px;
  z-index: 100;
}
.custom-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 15px;
  padding: 20px 10px;
  border-radius: 10px;
  background: #fff;
  >div {
    text-align: center;
  }
}
.form-item {
  display: flex;
  align-items: center;
  padding:  10px 15px;
  overflow: hidden;
  &:last-child {
    border-bottom: 1px solid  transparent;
  }
}
.form-item.form-item-button {
  padding: 30px 0  0;
}
.phone-img {
  margin: 20px auto 20px;
  width: 70px;
}
.phone-desc {
  line-height: 1.6;
  text-align: center;
}
.coupon-img {
  height: 80px;
  max-width: 310px;
  margin: 20px auto 5px;
  text-align: center;
}
.desc-1 {
  margin-bottom: 3px;
  font-size: 18px;
  color: #4E73F4;
}
.desc-2 {
  padding: 0 15px;
  font-size: 14px;
  color: #282828;
}

.form-button {
  box-sizing: border-box;
  width: 90%;
  margin: 0 auto 12px;
  padding: 8px 5px;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  outline: none;
  background-color:#4E73F4;
  font-weight: 600;
}
</style>
